import { sortBy } from 'lodash';

import { PATENT_LICENSES, SOFTWARE_LICENSES } from '@shared/utils/constants';

// `Other` and `TBD` are catch-all options, not real licenses — pin them last.
const PINNED_SOFTWARE_LAST = new Set(['Other', 'TBD']);

// `No Patent License` / `Not Applicable` are non-licenses — pin them last.
// Option labels intentionally keep "Patent License" wording to match stored backend values.
const PINNED_SPECIFICATION_LAST = new Set(['No Patent License', 'Not Applicable']);

export function softwareLicenseOptions() {
  const pinned = SOFTWARE_LICENSES.filter((option) => PINNED_SOFTWARE_LAST.has(option.label));
  const rest = sortBy(
    SOFTWARE_LICENSES.filter((option) => !PINNED_SOFTWARE_LAST.has(option.label)),
    'label'
  );
  return [...rest, ...sortBy(pinned, 'label')];
}

export function specificationLicenseOptions() {
  const pinned = PATENT_LICENSES.filter((option) => PINNED_SPECIFICATION_LAST.has(option.label));
  const rest = sortBy(
    PATENT_LICENSES.filter((option) => !PINNED_SPECIFICATION_LAST.has(option.label)),
    'label'
  );
  return [...rest, ...sortBy(pinned, 'label')];
}

// Stored values (e.g. legacy "TBD / NA") may differ from the displayed label.
export function softwareLicenseLabel(value?: string | null): string {
  if (!value) {
    return '-';
  }
  return SOFTWARE_LICENSES.find((option) => option.value === value)?.label ?? value;
}

// Stored values may differ from the displayed label.
export function specificationLicenseLabel(value?: string | null): string {
  if (!value) {
    return '-';
  }
  return PATENT_LICENSES.find((option) => option.value === value)?.label ?? value;
}
